
import merge from 'deepmerge'
import FacturaMessages from './messages/FacturaMessages'

import FacturaPermissionMessages from './permissions/FacturaPermissionMessages'
import AfipPermissionMessages from './permissions/AfipPermissionMessages'


const messages = merge.all([
    FacturaMessages,

    FacturaPermissionMessages,
    AfipPermissionMessages
])

export default messages;
